
import { Search, Brain, CalendarCheck, RotateCcw } from 'lucide-react';

const HowItWorksSection = () => {
  const steps = [
    {
      number: '1',
      icon: Search,
      title: 'Choose what to experiment with',
      description: 'Tell us what you want to explore',
      example: '"I want to explore morning routines"'
    },
    {
      number: '2',
      icon: Brain,
      title: 'AI suggests PACTs',
      description: 'Get personalized "I will [action] for [duration]" suggestions',
      example: '"I will read 10 pages for 21 days"'
    },
    {
      number: '3',
      icon: CalendarCheck,
      title: 'Show up daily (or don\'t)',
      description: 'Track honestly - it\'s an experiment',
      example: 'Simple yes/no tracking each day'
    },
    {
      number: '4',
      icon: RotateCcw,
      title: 'Complete and decide what\'s next',
      description: 'Celebrate completion, then choose your next experiment',
      example: 'Continue, modify, or try something new'
    }
  ];

  return (
    <section className="container max-w-6xl mx-auto px-4 py-24">
      <div className="text-center mb-16">
        <h2 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">
          How it
          <span className="block text-yellow-400">works</span>
        </h2>
        <p className="text-xl text-white/90 max-w-3xl mx-auto font-medium">
          Four simple steps to start experimenting with life
        </p>
      </div>

      <div className="grid lg:grid-cols-4 gap-8">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <div key={index} className="text-center relative">
              {/* Step Number */}
              <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <span className="text-2xl font-black text-purple-800">{step.number}</span>
              </div>
              
              {/* Icon */}
              <div className="w-20 h-20 bg-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 border border-white/20">
                <Icon className="w-10 h-10 text-white" />
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-white mb-4">{step.title}</h3>
              <p className="text-white/80 mb-4 font-medium leading-relaxed">{step.description}</p>
              
              {/* Example */}
              <div className="bg-yellow-400/10 rounded-2xl p-4 border border-yellow-400/20">
                <p className="text-yellow-400 font-medium text-sm">{step.example}</p>
              </div>
              
              {/* Arrow (except for last step) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 -right-4 w-8 h-8 text-white/40">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
                  </svg>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HowItWorksSection;
